import { render, staticRenderFns } from "./AdditionaModel.vue?vue&type=template&id=76274eb6&scoped=true&"
import script from "./AdditionaModel.vue?vue&type=script&lang=js&"
export * from "./AdditionaModel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76274eb6",
  null
  
)

export default component.exports